const paymentsSelector = (state) => state.banqueDeFrance.payments

const financesSelector = (state) => state.banqueDeFrance.finances

const ratingSelector = (state) => state.banqueDeFrance.rating

export { paymentsSelector, financesSelector, ratingSelector }
